import { makeAutoObservable, runInAction } from "mobx";
import { rootContainer, TYPE } from "../services/container/root";
import MerchantVideoService, { IMerchantVideo, MERCHANT_VIDEO_SECTIONS } from "../services/api/merchant-video-service";

class MerchantVideoStore {
    private _isLoading: boolean = false;
    private _dashboardVideos: IMerchantVideo[] = [];
    private _dashboardVideosLoaded: boolean = false;

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    private get service(): MerchantVideoService {
        return rootContainer.get<MerchantVideoService>(TYPE.MerchantVideoService);
    }

    public get dashboardVideos(): IMerchantVideo[] {
        return this._dashboardVideos;
    }

    public get dashboardVideosLoaded(): boolean {
        return this._dashboardVideosLoaded;
    }

    public get isLoading(): boolean {
        return this._isLoading;
    }

    public async load() {
        this._isLoading = true;
        const dashboardVideos = await this.service.loadVideosOfSection(MERCHANT_VIDEO_SECTIONS.DASHBOARD);
        try {
            runInAction(() => {
                this._isLoading = false;
                this._dashboardVideos = dashboardVideos;
                this._dashboardVideosLoaded = true;
            });
        } catch (error) {
            console.error(error);
            runInAction(() => {
                this._isLoading = false;
            });
        }
    }
}

export default new MerchantVideoStore();